import tw, { styled } from 'twin.macro'

export const ScrollTopButtonRoot = styled.button`
    ${tw`z-50 mr-2 fixed bottom-1 left-3 mb-5 w-14 h-14 rounded-full bg-main-bgCTABannerButton hover:opacity-80 flex justify-center items-center`}
`
